<!-- <template>
    <div v-for="member_set in response_data" :key="member_set.first_level" class = "member-group">
        <p style="color: #000;font-family: Arial;font-size: 36px;font-style: italic;font-weight: 700;line-height: 26px;letter-spacing: 0.9px;">
            {{ member_set.first_level }}
        </p>
        <div v-for="member_group in member_set.member_groups" class = "member-list">
            <p v-if="member_group.second_level" style="color: #000;font-family: Arial;font-size: 20px;font-style: italic;font-weight: 700;line-height: 26px;letter-spacing: 0.5px;">
            {{ member_group.second_level }}
            </p>
            <MemberList :items="member_group.member_list"></MemberList>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, nextTick, defineProps } from 'vue';
import axios from 'axios';
import MemberList from '@/components/MemberList.vue';
interface Member {
  name: string;
  memberDescribe: string;
  mail: string;
  personalPage: string;
  major: string;
  imageLink: string;
}

interface MemberGroup {
  second_level: string;
  member_list: Member[];
}

interface MemberSet {
  first_level: string;
  member_groups: MemberGroup[];
}
const BaseUrl = "https://api.beijingcitylab.org:8080"
const defaultImage = "https://bcl-serve.obs.cn-north-4.myhuaweicloud.com/404.jpg";
const response_data = ref<MemberSet[]>([]);
onMounted(async () => {
    const response = await axios.get(BaseUrl + '/api/f/all_member');
    response_data.value = response.data;
    console.log(response.data);
})
</script>

<style scoped>
.member-group{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    align-self: stretch;
    margin-bottom: 50px;
}

.member-list{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
}
</style> -->
<template>
  <div v-for="member_set in response_data" :key="member_set.first_level" class="member-group">
    <p style="color: #000;font-family: Arial;font-size: 36px;font-style: italic;font-weight: 700;line-height: 26px;letter-spacing: 0.9px;">
      {{ member_set.first_level }}
    </p>
    <div v-for="member_group in member_set.member_groups" class="member-list">
      <p
        v-if="member_group.second_level"
        style="color: #000;font-family: Arial;font-size: 20px;font-style: italic;font-weight: 700;line-height: 26px;letter-spacing: 0.5px;"
      >
        {{ member_group.second_level }}
      </p>
      <MemberList :items="member_group.member_list"></MemberList>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import axios from 'axios';
import MemberList from '@/components/MemberList.vue';

interface Member {
  name: string;
  memberDescribe: string;
  mail: string;
  personalPage: string;
  major: string;
  imageLink: string;
}

interface MemberGroup {
  second_level: string;
  member_list: Member[];
}

interface MemberSet {
  first_level: string;
  member_groups: MemberGroup[];
}

const BaseUrl = "https://api.beijingcitylab.org:8080";
const defaultImage = "https://bcl-serve.obs.cn-north-4.myhuaweicloud.com/404.jpg";
const response_data = ref<MemberSet[]>([]);

onMounted(async () => {
  const response = await axios.get(BaseUrl + '/api/f/all_member');
  const data: MemberSet[] = response.data;

  // 替换规则映射表
  const replacements: Record<string, string> = {
    "Current Members": "Current members",
    "Postdoctoral Fellow": "Postdoctoral fellows",
    "Doctoral student": "Doctoral students",
    "Master student": "Master students",
    "Research assistant": "Research assistants",
    "Former Postdoctoral Fellow": "Former postdoctoral fellows",
    "Former Doctoral student": "Former doctoral students",
    "Former Master student": "Former master students",
    "Former Research assistant": "Former research assistants",
    "Former Intern students": "Former intern students",
    "Former Visiting students": "Former visiting students",
  };

  // 遍历并替换字段
  for (const memberSet of data) {
    if (replacements[memberSet.first_level]) {
      memberSet.first_level = replacements[memberSet.first_level];
    }
    for (const group of memberSet.member_groups) {
      if (replacements[group.second_level]) {
        group.second_level = replacements[group.second_level];
      }
    }
  }

  response_data.value = data;
  console.log(data);
});
</script>

<style scoped>
.member-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  align-self: stretch;
  margin-bottom: 50px;
}

.member-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
</style>
